export default __webpack_public_path__ + "static/media/minus.09e82ad3.svg";